export const templates = [
  {
    id: 'modern-tech',
    name: 'Modern Tech',
    desc: 'Two-column layout, designed for tech roles with skills emphasis.',
    pages: 2,
    ats: false,
    profession: 'Tech',
  },
  {
    id: 'ats-classic',
    name: 'ATS Classic',
    desc: 'Clean, one-column, strictly parsed format for maximum ATS success.',
    pages: 1,
    ats: true,
    profession: 'Generic',
  },
  {
    id: 'creative-minimal',
    name: 'Creative Minimal',
    desc: 'Bold header and sparse data design for designers and creatives.',
    pages: 1,
    ats: false,
    profession: 'Design',
  },
  {
    id: 'executive',
    name: 'Executive Leader',
    desc: 'Authoritative styling with prominent summary for management roles.',
    pages: 2,
    ats: true,
    profession: 'Management',
  },
  {
    id: 'startup',
    name: 'Startup Hustle',
    desc: 'Dense, modern sans-serif layout perfect for dynamic startup roles.',
    pages: 1,
    ats: false,
    profession: 'Tech',
  },
  {
    id: 'academic',
    name: 'Academic Scholar',
    desc: 'Traditional focused layout emphasizing publications and education.',
    pages: 2,
    ats: true,
    profession: 'Education',
  },
  {
    id: 'finance-pro',
    name: 'Finance Pro',
    desc: 'Ultra-conservative data-dense format tailored for banking/finance.',
    pages: 1,
    ats: true,
    profession: 'Finance',
  },
  {
    id: 'healthcare',
    name: 'Healthcare Hero',
    desc: 'Soft styling focusing on certifications, licenses, and clinical experience.',
    pages: 1,
    ats: true,
    profession: 'Medical',
  },
  {
    id: 'engineer',
    name: 'The Engineer',
    desc: 'Grid-based technical skills upfront for software and civil engineers.',
    pages: 1,
    ats: true,
    profession: 'Engineering',
  },
  {
    id: 'elegant',
    name: 'Elegant Professional',
    desc: 'Spacious serif design ideal for law, consulting, and formal applications.',
    pages: 1,
    ats: false,
    profession: 'Generic',
  },
  {
    id: 'pro-1',
    name: 'Software Engineer',
    desc: 'Full-stack, backend or frontend developers',
    pages: 1,
    ats: true,
    profession: 'Tech'
  },
  {
    id: 'pro-2',
    name: 'Data Scientist',
    desc: 'AI, analytics and ML professionals',
    pages: 1,
    ats: true,
    profession: 'Tech'
  },
  {
    id: 'pro-3',
    name: 'UI UX Designer',
    desc: 'Product designers and researchers',
    pages: 1,
    ats: true,
    profession: 'Tech'
  },
  {
    id: 'pro-4',
    name: 'DevOps',
    desc: 'Infrastructure and platform engineers',
    pages: 1,
    ats: true,
    profession: 'Tech'
  },
  {
    id: 'pro-5',
    name: 'Cybersecurity Analyst',
    desc: 'SOC analysts and pen testers',
    pages: 1,
    ats: true,
    profession: 'Tech'
  },
  {
    id: 'pro-6',
    name: 'Financial Analyst',
    desc: 'Corporate finance and FP&A',
    pages: 1,
    ats: true,
    profession: 'Finance'
  },
  {
    id: 'pro-7',
    name: 'Accountant Auditor',
    desc: 'General accountants and audit professionals',
    pages: 1,
    ats: true,
    profession: 'Finance'
  },
  {
    id: 'pro-8',
    name: 'Investment Banker',
    desc: 'M&A, capital markets advisory',
    pages: 1,
    ats: true,
    profession: 'Finance'
  },
  {
    id: 'pro-9',
    name: 'Digital Marketing Manager',
    desc: 'SEO, paid media and growth',
    pages: 1,
    ats: true,
    profession: 'Marketing'
  },
  {
    id: 'pro-10',
    name: 'Brand Manager',
    desc: 'Brand strategy in FMCG',
    pages: 1,
    ats: true,
    profession: 'Marketing'
  },
  {
    id: 'pro-11',
    name: 'Medical Doctor',
    desc: 'General practitioners and specialists',
    pages: 1,
    ats: true,
    profession: 'Healthcare'
  },
  {
    id: 'pro-12',
    name: 'Registered Nurse',
    desc: 'Clinical nurses across hospital units',
    pages: 1,
    ats: true,
    profession: 'Healthcare'
  },
  {
    id: 'pro-13',
    name: 'Pharmacist',
    desc: 'Clinical, retail and hospital pharmacists',
    pages: 1,
    ats: true,
    profession: 'Healthcare'
  },
  {
    id: 'pro-14',
    name: 'Civil Structural Engineer',
    desc: 'Infrastructure and building design',
    pages: 1,
    ats: true,
    profession: 'Engineering'
  },
  {
    id: 'pro-15',
    name: 'Electrical Engineer',
    desc: 'Power systems, ELV, automation',
    pages: 1,
    ats: true,
    profession: 'Engineering'
  },
  {
    id: 'pro-16',
    name: 'Mechanical Engineer',
    desc: 'HVAC, MEP, manufacturing',
    pages: 1,
    ats: true,
    profession: 'Engineering'
  },
  {
    id: 'pro-17',
    name: 'Lawyer Legal Counsel',
    desc: 'In-house counsel and lawyers',
    pages: 1,
    ats: true,
    profession: 'Legal'
  },
  {
    id: 'pro-18',
    name: 'Compliance Officer',
    desc: 'AML, regulatory and corporate compliance',
    pages: 1,
    ats: true,
    profession: 'Legal'
  },
  {
    id: 'pro-19',
    name: 'School Teacher',
    desc: 'Primary and secondary educators',
    pages: 1,
    ats: true,
    profession: 'Education'
  },
  {
    id: 'pro-20',
    name: 'University Lecturer',
    desc: 'Higher education teaching and research',
    pages: 1,
    ats: true,
    profession: 'Education'
  },
  {
    id: 'pro-21',
    name: 'Hotel Manager',
    desc: 'Hospitality and F&B operations',
    pages: 1,
    ats: true,
    profession: 'Hospitality'
  },
  {
    id: 'pro-22',
    name: 'Chef Head Chef',
    desc: 'Executive, sous and specialist chefs',
    pages: 1,
    ats: true,
    profession: 'Hospitality'
  },
  {
    id: 'pro-23',
    name: 'Sales Manager',
    desc: 'B2B / B2C sales specialists',
    pages: 1,
    ats: true,
    profession: 'Sales'
  },
  {
    id: 'pro-24',
    name: 'Real Estate Agent',
    desc: 'Property consultants',
    pages: 1,
    ats: true,
    profession: 'Sales'
  },
  {
    id: 'pro-25',
    name: 'HR Manager',
    desc: 'Human resources and talent partners',
    pages: 1,
    ats: true,
    profession: 'HR'
  },
  {
    id: 'pro-26',
    name: 'Supply Chain Manager',
    desc: 'End-to-end supply chain, procurement',
    pages: 1,
    ats: true,
    profession: 'Logistics'
  },
  {
    id: 'pro-27',
    name: 'Graphic Designer',
    desc: 'Visual communication, branding',
    pages: 1,
    ats: true,
    profession: 'Creative'
  },
  {
    id: 'pro-28',
    name: 'Content Creator',
    desc: 'Digital content, influencer management',
    pages: 1,
    ats: true,
    profession: 'Creative'
  },
  {
    id: 'pro-29',
    name: 'Executive Assistant',
    desc: 'C-suite support, office management',
    pages: 1,
    ats: true,
    profession: 'Admin'
  },
  {
    id: 'pro-30',
    name: 'Project Manager',
    desc: 'Construction and infrastructure',
    pages: 1,
    ats: true,
    profession: 'Construction'
  }
];
